import React from "react";
import BasicCustomField from "../BasicCustomField";
import { Calculation } from "../../../../../../src/application/Contracts";
import WaterSystemOptionModel = Calculation.WaterSystemOptionModel;
import formModelStore from "../../../../../store/FormModelStore";

export default class TwsTwsOptions extends BasicCustomField {
    state = {
        value: this.props.value || [],
        additionalModel: this.props.additionalModel,
    }
    onChangeInput = (twsOptionModel: WaterSystemOptionModel) => {
        let values = [...this.state.value]
        if (values.find(v => v.artNo === twsOptionModel.artNo)) {
            values = values.filter(v => v.artNo !== twsOptionModel.artNo);
        } else {
            values.push(twsOptionModel);
        }
        this.onChange(values);
    }
    renderRow = (twsOptionModel: WaterSystemOptionModel) => {
        return <tr key={twsOptionModel.artNo}>
            <td>
                <div className={`table-radio-button`}>
                    <input id={`tws-option-${twsOptionModel.artNo}`} type={"checkbox"}
                        checked={this.checkedRow(twsOptionModel.artNo) ?? false}
                        name={`tws-option`}
                        onChange={() => this.onChangeInput(twsOptionModel)} />
                    <label htmlFor={`tws-option-${twsOptionModel.artNo}`}></label>
                </div>
            </td>
            <td>{twsOptionModel.artNo}</td>
            <td>{twsOptionModel.description}</td>
        </tr>
    }

    checkedRow = (row: string) => {
        return formModelStore.formModel?.waterSystem?.selectedTWSOptions?.value?.some((v: {
            artNo: string;
        }) => v.artNo === row);
    }
    renderEmpty = () => {
        return <div className={`empty-expandable-container-results`}>{__('No options available')}</div>
    }

    clear = () => {
        formModelStore.formModel.waterSystem.selectedTWSOptions.value = null;
        this.setState({ value: [] });
    };

    getAvailableOptions = () => {
        let selectedInGroups = formModelStore.formModel?.waterSystem?.selectedTWSOptions?.value?.map((v: WaterSystemOptionModel) => v.oneOfGroup);
        let selectedArt = formModelStore.formModel?.waterSystem?.selectedTWSOptions?.value?.map((v: WaterSystemOptionModel) => v.artNo);
        if (!selectedInGroups || !selectedArt) {
            return (this.props.additionalModel as WaterSystemOptionModel[]);
        }
        return (this.props.additionalModel as WaterSystemOptionModel[]).filter(m => m.oneOfGroup === null || selectedInGroups.indexOf(m.oneOfGroup) < 0 || selectedArt.indexOf(m.artNo) > -1);
    }

    render() {
        if ((this.props.additionalModel as WaterSystemOptionModel[]).length === 0) {
            return this.renderEmpty();
        }

        return <React.Fragment>
            <table className={`step-stripped-table data-only`}>
                <thead>
                    <tr>
                        <th></th>
                        <th>{__('Art.No')}</th>
                        <th>{__('Description')}</th>
                    </tr>
                </thead>
                <tbody>
                    {this.getAvailableOptions().map(this.renderRow)}
                </tbody>
            </table>
        </React.Fragment>
    }
}